import { useCallback, useState } from 'react';

const useToggle = (initialState = false): [boolean, { toggle: any; setToggleState: any; }] => {
    const [state, setState] = useState<boolean>(initialState);
    const toggle = useCallback((): void => setState(stateValue => !stateValue), []);
    const setToggleState = (value: boolean): void => setState(Boolean(value));

    return [state, { toggle, setToggleState }];
};

export default useToggle;
